/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

export enum LeadTaskType {
    ContactAttempt = 'contact_attempt',
    FollowUp = 'follow_up',
    Call = 'call',
    Email = 'email',
    Other = 'other',
    // Legacy — kept for backward compatibility with existing data
    Meeting = 'meeting',
    SendOffer = 'send_offer',
}
